import { Link } from "react-router-dom";
import { categories, site } from "@/mocks/portal";

export default function SiteFooter() {
  return (
    <footer className="mt-auto bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/95 text-primary-800 font-heading text-lg font-bold">
                料
              </span>
              <span className="font-heading text-xl font-black tracking-tight">{site.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/70">
              一个专注影视综艺、音乐现场、生活方式与文化社会话题的内容聚合阅读门户。热门内容，一站看全，陪你好好吃饭、好好追剧、好好生活。
            </p>
            <p className="mt-4 text-sm text-background-50/60">
              联系邮箱：{site.contact.email} · 官方号：{site.contact.wechat}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            <div>
              <h4 className="text-sm font-semibold text-background-50">栏目导航</h4>
              <ul className="mt-4 space-y-2.5 text-sm text-background-50/70">
                <li>
                  <Link to="/" className="transition-colors hover:text-background-50">
                    首页精选
                  </Link>
                </li>
                {categories.map((c) => (
                  <li key={c.slug}>
                    <Link to={`/column/${c.slug}`} className="transition-colors hover:text-background-50">
                      {c.name} · {c.tagline}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50">了解更多</h4>
              <ul className="mt-4 space-y-2.5 text-sm text-background-50/70">
                <li>
                  <Link to="/about" className="transition-colors hover:text-background-50">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/#faq" className="transition-colors hover:text-background-50">
                    常见问题
                  </Link>
                </li>
                <li>
                  <Link to="/about#principles" className="transition-colors hover:text-background-50">
                    内容原则
                  </Link>
                </li>
                <li>
                  <Link to="/about#contact" className="transition-colors hover:text-background-50">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50">内容精选</h4>
              <ul className="mt-4 space-y-2.5 text-sm text-background-50/70">
                <li>
                  <Link to="/article/autumn-healing-dramas" className="transition-colors hover:text-background-50">
                    秋冬治愈剧片单
                  </Link>
                </li>
                <li>
                  <Link to="/article/gong-yi-yue-dui-ji-lu" className="transition-colors hover:text-background-50">
                    现场演出的复兴
                  </Link>
                </li>
                <li>
                  <Link to="/article/ban-gong-shi-zhuang-xiu" className="transition-colors hover:text-background-50">
                    40㎡ 松弛感改造
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-50/50">
            © {new Date().getFullYear()} {site.name} · 让值得看的内容被更多人看见
          </p>
          <div className="flex items-center gap-4 text-background-50/50">
            <a href="#" rel="nofollow" className="text-xs hover:text-background-50">
              <i className="ri-arrow-up-line" /> 回到顶部
            </a>
            <span className="text-xs">热爱内容，也尊重真实</span>
          </div>
        </div>
      </div>
    </footer>
  );
}